import { useEffect } from 'react';
import AOS from 'aos';
import WhyCard from '../ui/WhyCard';
import {
  FaCode,
  FaMobileAlt,
  FaShieldAlt,
  FaBolt,
  FaSearch,
  FaHeadset,
  FaProjectDiagram,
  FaComments,
} from "react-icons/fa";

const reasons = [
  { icon: FaCode, title: "Clean & Maintainable Code" },
  { icon: FaMobileAlt, title: "Responsive Design" },
  { icon: FaShieldAlt, title: "Secure Backend Development" },
  { icon: FaBolt, title: "Fast Performance" },
  { icon: FaSearch, title: "SEO-Friendly Development" },
  { icon: FaHeadset, title: "Ongoing Support" },
  { icon: FaProjectDiagram, title: "Scalable Architecture" },
  { icon: FaComments, title: "Client-Focused Communication" },
];

const WhyChooseMeSection = () => {
  useEffect(() => {
    AOS.refresh();
  }, []);

  return (
    <section className="section mt-0" id="why-choose-me" style={{ background: '#f9f9f9' }}>
      <div className="container">
        <div className="text-center mb-5" data-aos="fade-up">
          <h2 className="section-title">Why Choose Me</h2>
          <p className="section-subtitle">
            I bring expertise, dedication, and a client-first approach to every project.
          </p>
        </div>
        <div className="row">
          {reasons.map((reason, index) => (
            <WhyCard
              key={index}
              icon={reason.icon}
              title={reason.title}
              delay={index * 50}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseMeSection;
